<h1 mat-dialog-title>
  <strong>Ajouter au groupe {{ group.name }}</strong>
</h1>
<form (ngSubmit)="submit()">
  <div mat-dialog-content class="overflow-hidden">
    <div class="d-grid">
      <syn-candidate-picker (addCandidate)="addCandidate($event)" [group]="group" class="mt-3" />
      <div class="d-flex flex-row justify-content-center">
        @if (send) {
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        }
      </div>
    </div>
  </div>
  <mat-dialog-actions class="justify-content-end">
    <button mat-raised-button mat-dialog-close>Annuler</button>
    <button
      mat-raised-button
      color="primary"
      type="submit"
      [disabled]="!this.candidatesToAdd || this.candidatesToAdd.length === 0">
      Ajouter
    </button>
  </mat-dialog-actions>
</form>
